// Skeletons stand in for content, so they follow the small radius used by
// the elements they replace (inputs, table cells, tags) rather than the
// larger container radius Aura inherits from {content.border.radius}.
//
// Aura's own dark value, rgba(255,255,255,0.06), lands at roughly 1.1:1 over
// our page background and is effectively invisible, so both modes name a solid
// surface step instead.
//
// READ THIS BEFORE CHANGING A SURFACE NUMBER HERE. The dark surface ramp in
// mo-primeng-theme.ts is inverted: dark {surface.100} is {gray.700} and dark
// {surface.700} is {gray.100}, all the way up to {surface.900} being pure
// white. A low number is the DARK step in dark mode, the opposite of light
// mode. Naming {surface.700} for dark — which reads like a dark step and is
// what this file did until the placeholders turned up near-white on the
// organization dashboard — resolves to #f4f4f5.
//
// Both entries below are the same two greys the rest of the app already uses
// for placeholders: #e4e4e7 and #3f3f46, which is what --text-bg-hover-2
// resolves to and what data-table's .loading-block renders.
//
// animationBackground is the middle stop of a
// linear-gradient(90deg, transparent, X, transparent) sweep overlay, so it
// has to stay translucent — a solid value would hide the skeleton beneath.
export const skeletonTheme = {
  root: {
    borderRadius: '{border.radius.sm}'
  },
  colorScheme: {
    light: {
      root: {
        background: '{surface.200}',
        animationBackground: 'rgba(255, 255, 255, 0.55)'
      }
    },
    dark: {
      root: {
        // {surface.100} — see the inverted-ramp note above. This is #3f3f46.
        background: '{surface.100}',
        animationBackground: 'rgba(255, 255, 255, 0.08)'
      }
    }
  }
};
